export const CSS = {
  container: "tab-nav",
};
